import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4y8zvjhgv: FaireProductEntity = {
  token: "p_v4y8zvjhgv",
  type: "product",
  name: "Magnesium Oil Night Spray 8oz",
  brandToken: "b_7gb3t4sxaw",
  brandName: "Life-Flo",
  imageUrl:
    "https://cdn.faire.com/fastly/15d11974448ed80768893a7529cd61bd91f832d85f71b1353abe37f966ebd366.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd24a73c06a421b4c09be9b998db685579d7bd94b991ca4de3c25f8858ed20dc.jpeg",
    "https://cdn.faire.com/fastly/0724e8c8598f0179d0470484e2f8cd2f08f1bcbadd0d2cb8e509da8d6e684f00.jpeg",
  ],
  priceDollars: 15.03,
  description:
    "When a hectic day has kept you on-the-run, Life-flo Magnesium Night Spray may help calm your body and mind so you can get the rest you need.\n\nYour best bedtime companion, our powerful spray is made with highly concentrated magnesium chloride from the Netherlands’ ancient Zechstein Seabed, one of the world’s most pristine sources. We blend it with soothing arnica to help relax overworked muscles and joints, plus fragrant, calming lavender oil.\n\nSpray on nightly as needed, massaging onto skin and soft tissues for soothing, all-over relaxation after a long day on your feet or a time of high stress. This gentle, non-greasy formula is designed to go to work quickly and leave you with a warm, comforting sensation that lasts.",
  tags: [],
  msrpDollars: 26.04,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:27.735Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
